import styled from "styled-components"
import media from "src/styles/media"
import image from "gatsby-image"

export const TechnologiesListWrapper = styled.section`
  position: relative;
  height: auto;
  width: 100%;
  z-index: 5;
  margin-top: 160px;

  ${media.greaterThan("lg")`
      margin-bottom: 40px;
    `}

  ${media.lessThan("md")`
       padding-top: 40px;
       padding-left: 20px;
       padding-right: 20px;
    `}
`

export const TechnologiesListHeader = styled.header`
  text-align: center;
  margin-bottom: 60px;
  color: var(--dark);

  ${media.lessThan("lg")`
        margin-bottom: 65px;
    `}

  ${media.lessThan("md")`
        margin-bottom: 50px;
    `}
`
export const TechnologiesListTitle = styled.h3`
  font-size: 44px;
  font-weight: 600;
  line-height: 0.8;
  margin-bottom: 30px;
  letter-spacing: -1.5px;
  text-align: inherit;

  ${media.lessThan("lg")`
        font-size: 50px;
        margin-bottom: 16px;
    `}

  ${media.lessThan("sm")`
        font-size: 40px;
    `}
`

export const TechnologiesListSubTitle = styled.h2`
  font-weight: 300;
  font-size: 22px;
  margin-bottom: 4px;
  font-weight: normal;
  letter-spacing: 1px;

  ${media.lessThan("md")`
       text-align: center;
    `}

  ${media.lessThan("md")`
       font-size: 16px;
    `}
`

export const TechnologiesListList = styled.div`
  width: 64%;
  margin: 0 auto;

  ${media.lessThan("md")`
        width: 100%;
    `}
`

export const TechnologiesListItem = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 40px;
  height: 90px;
  transition: transform 0.4s;

  &:hover {
    transform: scale(1.05);
  }

  ${media.lessThan("md")`
        margin-bottom: 30px;
        height: 60px;
    `}
`

export const TechnologiesListItemImage = styled(image)`
  width: 85%;
  height: 100%;

  img {
    width: 100%;
    object-fit: contain !important;
    object-position: center center;
    max-height: 100%;
  }

  ${media.lessThan("md")`
        width: 90%;
    `}
`
